import styled from 'styled-components';

import { Button } from 'components/Button';
import { Input } from 'components/Input';
import { SelectWithControl } from 'components/SelectWithControl';

const Container = styled.div`
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  gap: 2rem;
`;

const Select = styled(SelectWithControl)`
  width: 30rem;
`;

const EmailInput = styled(Input)`
  width: 30rem;
  text-transform: uppercase;
`;

const ActionButton = styled(Button)`
  justify-content: center;
  width: 30rem;
  height: 5rem;
`;

const MessageContainer = styled.div`
  display: flex;
  flex-direction: column;
  gap: 1rem;
  text-align: center;
  max-width: 30rem;
  background-color: #f3fafd;
  border-radius: 15px;
  padding: 15px;
  color: #000;
  .headline-normal-whitespace {
    white-space: normal;
  }
`;

export { Container, Select, EmailInput, ActionButton, MessageContainer };
